var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c("FullCalendar", {
        ref: "calendar",
        attrs: {
          events: _vm.lunchOptions,
          defaultView: "dayGridMonth",
          weekends: _vm.calendarWeekends,
          plugins: _vm.calendarPlugins,
          datesRender: _vm.loadLunchMenus,
          eventRender: _vm.updateEvents,
          locale:
            _vm.getSelectedLocale.LOCALE_CODE !== "sa-us"
              ? _vm.getSelectedLocale.LOCALE_CODE
              : "en-us",
          buttonText: { today: _vm.$t("MAIN_CONTENT.StudentCalendar.today") }
        },
        on: { dateClick: _vm.handleDateClick }
      }),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            "modal-title": _vm.$t("MAIN_CONTENT.Calendar.lunchMenuModalTitle", {
              date: _vm.selectedDay,
              school: _vm.selectedSchool.SCHOOL_TITLE
            }),
            show: _vm.showLunchMenuModal,
            "dialog-size": "md",
            name: "lunchMenu",
            fields: ""
          },
          on: {
            close: function($event) {
              return _vm.closeLunchMenuModal()
            }
          }
        },
        [
          _vm._l(_vm.selectedDayLunchOptions, function(lunch, lunchIndex) {
            return _c("p", {
              key: "lunchModal_" + lunchIndex,
              domProps: { innerHTML: _vm._s(_vm.formatText(lunch.LUNCH_MENU)) }
            })
          }),
          _vm._v(" "),
          _c(
            "template",
            { attrs: { close: _vm.closeLunchMenuModal }, slot: "footer" },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-default",
                  attrs: { type: "button" },
                  on: { click: _vm.closeLunchMenuModal }
                },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.$t("MAIN_CONTENT.commonContent.closeButton")) +
                      "\n\t\t\t"
                  )
                ]
              )
            ]
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }